import { Mask } from './Mask';
import { Player } from '../game/Player';

export class HermesMask extends Mask {
  private baseSpeedMultiplier: number = 1.5; // Passive speed boost
  
  constructor(player: Player) {
    super(
      'Mask of Hermes',
      'Speed boost and time manipulation',
      0xffa500, // Orange
      player
    );
    
    this.maxAbilityDuration = 3; // 3 seconds of time slow
    this.cooldownTime = 8; // 8 second cooldown
  }
  
  protected onActivate(): void {
    // Apply passive speed boost
    this.player.speedMultiplier = this.baseSpeedMultiplier;
  }
  
  protected onDeactivate(): void {
    // Remove speed boost
    this.player.speedMultiplier = 1;
  }
  
  protected onUpdate(_deltaTime: number): void {
    // Nothing special needed
  }
  
  protected onAbilityStart(): void {
    // Time slow effect is handled by Game.ts checking isAbilityActive()
    console.log('Time slowing...');
  }
  
  protected onAbilityEnd(): void {
    console.log('Time resuming...');
  }
}
